import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { storageKey } from 'libs/core/src/app.const';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';
import { CountdownComponentService } from 'libs/core/src/lib/service/countdown.service';
import { StateService } from 'libs/core/src/lib/state/state.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { filter } from 'rxjs';
import { TitleService } from 'libs/core/src/lib/service/title.service';

@Component({
  template: '',
  standalone: false
})
export class ErrorPageComponent implements OnInit, AfterViewInit {
  public id: string = null;
  public message: any = null;

  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    protected router: Router,
    protected route: ActivatedRoute,
    protected translateService: TranslateService,
    protected countdownComponentService: CountdownComponentService,
    protected stateService: StateService,
    protected modalService: BsModalService,
    protected loaderService: LoaderService,
    protected titleService: TitleService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params.id;
      this.prepareMessage(this.id);
    });
    this.countdownComponentService.hide();
    this.modalService.hide();
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.loaderService.hideLoader(LoaderEnum.MAIN);
    });
  }

  ngAfterViewInit(): void {
    this.loaderService.hideLoader(LoaderEnum.MAIN);
  }

  ngAfterViewChecked() {
    this.titleService.setTitle(this.translateService.instant('error.pageTitle'));
  }

  //overridden by extension components
  setButtonLabel() {}

  setMessage(res: Object) {
    this.message = res;
    this.setButtonLabel();
  }

  private prepareMessage(id: string) {
    this.translateService.get(`message.${id}`).subscribe({
      next: (res: Object) => this.setMessage(res),
      error: (e) => this.translateService.get(`message.default`).subscribe((res: Object) => this.setMessage(res))
    });
  }

  goToRepertoire() {
    const backUrl = this.stateService.getItem(storageKey.backUrl);
    window.location.href = backUrl ? backUrl : this.environment.backUrl;
  }
}
